/**
 * Staff Market access — Lab `profile.bookmakerSessionFlag`.
 *
 * Set on Access Level create/edit; sent on books / account-statement calls so
 * onlyBookmaker / onlySession / bookmakerSession staff only see allowed markets.
 */

export type BookmakerSessionFlag =
  | 'all'
  | 'onlyBookmaker'
  | 'onlySession'
  | 'bookmakerSession'

const FLAGS: BookmakerSessionFlag[] = [
  'all',
  'onlyBookmaker',
  'onlySession',
  'bookmakerSession',
]

export function resolveBookmakerSessionFlag(
  raw: string | null | undefined,
): BookmakerSessionFlag {
  const value = (raw ?? 'all').trim() as BookmakerSessionFlag
  return FLAGS.includes(value) ? value : 'all'
}

/**
 * Lab getAllBets `marketType` when the operator has not picked a narrower chip.
 * `bookmakerSession` has no single Lab chip (BM + fancy, no MO) — leave unset
 * and rely on books/PL `bookmakerSessionFlag` filtering elsewhere.
 */
export function tickerMarketTypeForFlag(
  flag: BookmakerSessionFlag,
): 'Bookmaker' | 'Fancy' | undefined {
  if (flag === 'onlyBookmaker') return 'Bookmaker'
  if (flag === 'onlySession') return 'Fancy'
  return undefined
}
